import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFamiconsMoon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.53842 0.5979C6.98577 1.14148 6.5425 1.79698 6.23506 2.52531C5.92762 3.25363 5.76231 4.03987 5.74898 4.8371C5.73565 5.63433 5.87459 6.42622 6.1575 7.16555C6.44041 7.90487 6.86149 8.57647 7.39563 9.14029C7.92977 9.7041 8.56602 10.1486 9.26644 10.4472C9.96685 10.7458 10.7171 10.8925 11.4723 10.8784C12.2276 10.8643 12.9725 10.6899 13.6625 10.3653C14.3524 10.0408 14.9735 9.57292 15.4884 8.98957C15.2499 13.1339 11.9904 16.4162 8.00417 16.4162C3.86117 16.4162 0.503418 12.8719 0.503418 8.49952C0.503418 4.29182 3.61292 0.851234 7.53842 0.5979Z",
		fill: "#79c912"
	})
});
export default SvgFamiconsMoon;
